import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVocalMicrophone: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="vocal-microphone, singing, karaoke"><path d="M14.7517 13.25L6.53589 20.5391C5.67432 21.3034 4.36595 21.2646 3.55151 20.4502C2.73709 19.6358 2.69827 18.3274 3.46264 17.4658L10.7517 9.25L14.7517 13.25Z" fill="currentColor"/><path d="M16.5017 2.5C19.263 2.50015 21.5017 4.73867 21.5017 7.5C21.5017 10.2613 19.263 12.4998 16.5017 12.5C16.3023 12.5 16.1052 12.4885 15.9119 12.4658L11.5359 8.08984C11.5132 7.89639 11.5017 7.69956 11.5017 7.5C11.5017 4.73858 13.7403 2.5 16.5017 2.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconVocalMicrophone;
